/**
 * Injectable time source for the game loop.
 *
 * The loop is written against this interface from day one so "test mode"
 * is a matter of swapping which Clock gets constructed in main.ts, not
 * restructuring the render/update loop later.
 */
export interface Clock {
  /** Monotonic milliseconds, semantics matching performance.now(). */
  now(): number
}

/** Wall-clock time via the real performance.now(). Used outside test mode. */
export class RealClock implements Clock {
  now(): number {
    return performance.now()
  }
}

/**
 * A clock that only advances when told to. Used in test mode so the whole
 * simulation (physics timestep, animation, anything reading Date.now()) is
 * driven by an exact, replayable sequence of milliseconds instead of real
 * elapsed time.
 */
export class ManualClock implements Clock {
  private t: number

  constructor(startMs = 0) {
    this.t = startMs
  }

  now(): number {
    return this.t
  }

  advance(ms: number): void {
    this.t += ms
  }
}
